import styled from "styled-components";
import { Button } from "antd";

export const FloatingButton = styled(Button)`
  position: fixed !important;
  bottom: 30px;
  right: 30px;
  width: 60px !important;
  height: 60px !important;
  min-width: 60px !important;
  border-radius: 50% !important;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 8px 24px rgba(222, 40, 59, 0.2);
  transition: all 0.3s ease;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;

  &&.ant-btn-primary {
    background: linear-gradient(135deg, #de283b 0%, #b80000 100%);
    border: none;
    border-radius: 50% !important;

    &:hover {
      background: linear-gradient(135deg, #b80000 0%, #de283b 100%);
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2), 0 12px 32px rgba(222, 40, 59, 0.3);
    }

    &:active {
      transform: translateY(-1px);
    }
  }

  .ant-btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 56px !important;
    height: 56px !important;
    min-width: 56px !important;

    .anticon {
      font-size: 20px !important;
    }
  }

  @media (max-width: 480px) {
    bottom: 15px;
    right: 15px;
    width: 50px !important;
    height: 50px !important;
    min-width: 50px !important;

    .anticon {
      font-size: 18px !important;
    }
  }
`;
